import { createContext, useState } from "react";
import { useDispatch } from "react-redux";

import {
  createCancelingReasonService,
  deleteCancelingReasonService,
  getCancelingReasonService,
} from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";

export const cancelingReasonAdminContext = createContext({
  cancelingReasonItems: [],
  setCancelingReasonItems: () => {},
  description: "",
  setDescription: () => {},
  isShowModal: null,
  setIsShowModal: () => {},
  handleShowModal: () => {},
  handleCloseModal: () => {},
  handleGetCancelingReasonItemList: () => {},
  handleCreateCancelingReasonItem: () => {},
  handleDeleteCancelingReasonItem: () => {},
});

const CancelingReasonAdminContext = ({ children }) => {
  // Redux Dispatch
  const dispatch = useDispatch();

  const [cancelingReasonItems, setCancelingReasonItems] = useState([]);
  const [description, setDescription] = useState("");
  const [isShowModal, setIsShowModal] = useState(false);

  const handleResetState = () => {
    setDescription("");
  };

  // Create Canceling Reason Modal Operations
  const handleShowModal = () => setIsShowModal(true);
  const handleCloseModal = () => {
    setIsShowModal(false);
    handleResetState();
  };

  // Handle Get Canceling Reason Item List Method
  const handleGetCancelingReasonItemList = async (event) => {
    event?.preventDefault();
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getCancelingReasonService();
      if (status === 200) {
        setCancelingReasonItems(data.list);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Create Canceling Reason Item Method
  const handleCreateCancelingReasonItem = async (event) => {
    event?.preventDefault();

    const objData = {
      description,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await createCancelingReasonService(objData);
      if (status === 200) {
        toastSuccessMessage("آیتم با موفقیت ایجاد شد");
        handleGetCancelingReasonItemList();
        handleCloseModal();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Delete Canceling Reason Item Method
  const handleDeleteCancelingReasonItem = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status } = await deleteCancelingReasonService(id);
      if (status === 200) {
        toastSuccessMessage(`آیتم  ${id} با موفقیت حذف شد`);
        handleGetCancelingReasonItemList();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <cancelingReasonAdminContext.Provider
      value={{
        cancelingReasonItems,
        setCancelingReasonItems,
        description,
        setDescription,
        isShowModal,
        setIsShowModal,
        handleShowModal,
        handleCloseModal,
        handleGetCancelingReasonItemList,
        handleCreateCancelingReasonItem,
        handleDeleteCancelingReasonItem,
      }}
    >
      {children}
    </cancelingReasonAdminContext.Provider>
  );
};

export default CancelingReasonAdminContext;
